export const dict = {
  fr: {
    nav: {
      shop: "Boutique",
      story: "Notre histoire",
      faq: "FAQ",
      contact: "Contact",
      cart: "Panier",
    },
    hero: {
      eyebrow: "Bien-être · Édition 2026",
      title: "Le confort\nqui te suit\npartout.",
      subtitle:
        "Deux innovations pensées pour relâcher les tensions, où que la journée vous porte. Conçues en Europe. Livrées chez vous.",
      cta: "Découvrir",
      ctaSecondary: "Voir la collection",
    },
    reassurance: {
      shipping: { title: "Livraison Europe", sub: "3 à 14 jours selon le produit" },
      returns: { title: "Retours 30 jours", sub: "Sans questions, sans pression" },
      payment: { title: "Paiement sécurisé", sub: "Cryptage SSL, 100% protégé" },
      support: { title: "Support réactif", sub: "Réponse en moins de 24h" },
    },
    products: {
      eyebrow: "La collection",
      title: "Deux innovations. Une promesse.",
      sub: "Une collection courte, choisie avec soin. Chaque produit est éprouvé pendant des semaines avant d'arriver chez vous.",
      addToCart: "Je le veux, livré chez moi",
      viewProduct: "Voir le produit",
      from: "À partir de",
    },
    story: {
      eyebrow: "Pourquoi myFLOVEA",
      title: "Le bien-être ne devrait jamais rester à la maison.",
      body1:
        "Nous croyons que les meilleurs rituels de confort sont ceux qui voyagent avec vous. Dans le métro, sur un vol, derrière un bureau, à la maison.",
      body2:
        "myFLOVEA, c'est une sélection courte d'innovations bien-être tech, conçues pour être belles, silencieuses et faciles à vivre — pour vous, pas pour une étagère.",
      cta: "Découvrir la mission",
    },
    guarantees: {
      eyebrow: "Garanties myFLOVEA",
      title: "Acheter ici, c'est acheter en confiance.",
      items: [
        { title: "Livraison suivie", body: "Suivi en temps réel par email. 3 à 14 jours ouvrés selon le produit et la destination." },
        { title: "Satisfaction garantie", body: "30 jours pour changer d'avis. Retours simples, gratuits." },
        { title: "Satisfait ou remboursé", body: "Service client réactif basé en France." },
      ],
    },
    footer: {
      tagline: "Le confort qui te suit partout.",
      newsletter: {
        title: "-10% sur votre 1ère commande",
        sub: "Recevez votre code de bienvenue exclusif et nos rituels bien-être — un seul email par mois, jamais plus.",
        placeholder: "votre.email@exemple.com",
        submit: "S'inscrire",
        success: "Merci — votre code de bienvenue vous attend dans votre boîte mail.",
      },
      columns: { shop: "Boutique", about: "La maison", help: "Aide" },
      links: {
        cushion: "Coussin Massant",
        neck: "L'Anneau de Confort",
        story: "Notre histoire",
        faq: "FAQ",
        contact: "Contact",
        legal: "Mentions légales",
        cgv: "CGV",
        retractation: "Politique de rétractation",
        returns: "Politique de retour",
      },
      rights: "© 2026 myFLOVEA — Tous droits réservés.",
    },
    cart: {
      title: "Votre panier",
      empty: "Votre panier est encore vide.",
      emptyCta: "Explorer la collection",
      subtotal: "Sous-total",
      shipping: "Livraison",
      shippingFree: "Gratuite en Europe",
      total: "Total",
      checkout: "Passer commande",
      remove: "Retirer",
      qty: "Qté",
    },
    product: {
      addToCart: "Je le veux, livré chez moi",
      features: "Caractéristiques",
      back: "Retour",
      shipsFrom: "Livraison suivie en Europe",
      satisfied: "30 jours satisfait ou remboursé",
      priceNote: "Prix TTC, livraison gratuite en Europe",
      allInclusive: "✅ Prix tout inclus — livraison & taxes offerts",
      exerciseWithdrawal: "Exercer mon droit de rétractation",
      freeShipping: "Livraison gratuite",
      shippingDetailsTitle: "Détails livraison",
      chooseVariant: "Choisissez votre version",
      descriptionTitle: "L'innovation en détail",
      faqTitle: "Questions fréquentes",
      badgeBestseller: "Best-seller",
      badgeNew: "Nouveau",
      outOfStockTitle: "Temporairement épuisé",
      outOfStockMsg: "Laissez votre email pour être notifié en priorité",
      waitlistEmailPlaceholder: "votre@email.com",
      waitlistSubmit: "Me notifier",
      waitlistSuccess: "Merci. Vous serez parmi les premiers prévenus.",
      outOfStockCta: "Rupture de stock",
      reviewsTitle: "Ils ont essayé, ils ont adopté",
      verifiedBadge: "Avis vérifié",
      certificationsTitle: "Certifications",
      powerSupplyTitle: "Branchement",
      comparisonTitle: "Pourquoi pas un ventilateur classique ?",
      crossSellTitle: "Complétez votre setup confort",
      crossSellCta: "Découvrir",
      stickyAddCta: "Ajouter — ",
    },
    checkout: {
      title: "Finaliser la commande",
      back: "Retour à la boutique",
      contact: "Vos coordonnées",
      shipping: "Adresse de livraison",
      summary: "Résumé",
      placeOrder: "Confirmer la commande",
      processing: "Traitement…",
      success: "Commande confirmée",
      successMsg: "Merci pour votre confiance. Un email récapitulatif vous a été envoyé.",
      orderNumber: "Numéro de commande",
      continueShopping: "Continuer mes achats",
      fields: {
        email: "Email",
        firstName: "Prénom",
        lastName: "Nom",
        address: "Adresse",
        city: "Ville",
        postal: "Code postal",
        country: "Pays",
        phone: "Téléphone (optionnel)",
      },
      simulationNote: "Ceci est un paiement simulé — aucune carte ne sera débitée.",
    },
    legal: {
      legalTitle: "Mentions légales",
      cgvTitle: "Conditions générales de vente",
      returnsTitle: "Politique de retour",
      contactTitle: "Contactez-nous",
      faqTitle: "Questions fréquentes",
      contactSubmit: "Envoyer le message",
      contactSuccess: "Message reçu. Nous revenons vers vous sous 24h.",
      placeholder: "Cette page est en cours de rédaction. Voici un contenu placeholder pour la démonstration du site.",
    },
    common: {
      currency: "€",
      ttc: "Prix TTC",
    },
  },
  en: {
    nav: {
      shop: "Shop",
      story: "Our story",
      faq: "FAQ",
      contact: "Contact",
      cart: "Cart",
    },
    hero: {
      eyebrow: "Wellness · 2026 Edition",
      title: "Comfort\nthat follows\nyou everywhere.",
      subtitle:
        "Two innovations designed to release daily tension — wherever your day takes you. Made in Europe. Delivered to your door.",
      cta: "Discover",
      ctaSecondary: "See the collection",
    },
    reassurance: {
      shipping: { title: "Europe shipping", sub: "3 to 14 days depending on product" },
      returns: { title: "30-day returns", sub: "No questions, no pressure" },
      payment: { title: "Secure payment", sub: "SSL encryption, fully protected" },
      support: { title: "Friendly support", sub: "Replies under 24h" },
    },
    products: {
      eyebrow: "The collection",
      title: "Two innovations. One promise.",
      sub: "A short, considered collection. Every product is tested for weeks before reaching you.",
      addToCart: "I want it — deliver it",
      viewProduct: "View product",
      from: "From",
    },
    story: {
      eyebrow: "Why myFLOVEA",
      title: "Wellness shouldn't stay home.",
      body1:
        "We believe the best comfort rituals are the ones that travel with you. On the subway, on a flight, at a desk, at home.",
      body2:
        "myFLOVEA is a short collection of wellness-tech innovations designed to be quiet, beautiful and easy to live with — for you, not for a shelf.",
      cta: "Read our mission",
    },
    guarantees: {
      eyebrow: "myFLOVEA guarantees",
      title: "Shopping here is shopping with confidence.",
      items: [
        { title: "Tracked delivery", body: "Real-time tracking via email. 3 to 14 business days depending on product and destination." },
        { title: "Satisfaction guaranteed", body: "30 days to change your mind. Returns are simple and free." },
        { title: "Money-back guaranteed", body: "Friendly customer support based in France." },
      ],
    },
    footer: {
      tagline: "Comfort that follows you everywhere.",
      newsletter: {
        title: "10% off your first order",
        sub: "Get your exclusive welcome code and our wellness rituals — one email a month, never more.",
        placeholder: "your.email@example.com",
        submit: "Subscribe",
        success: "Thank you — your welcome code is in your inbox.",
      },
      columns: { shop: "Shop", about: "House", help: "Help" },
      links: {
        cushion: "Massage Cushion",
        neck: "The Comfort Ring",
        story: "Our story",
        faq: "FAQ",
        contact: "Contact",
        legal: "Legal notice",
        cgv: "Terms of sale",
        retractation: "Withdrawal policy",
        returns: "Return policy",
      },
      rights: "© 2026 myFLOVEA — All rights reserved.",
    },
    cart: {
      title: "Your cart",
      empty: "Your cart is still empty.",
      emptyCta: "Browse the collection",
      subtotal: "Subtotal",
      shipping: "Shipping",
      shippingFree: "Free in Europe",
      total: "Total",
      checkout: "Checkout",
      remove: "Remove",
      qty: "Qty",
    },
    product: {
      addToCart: "I want it — deliver it",
      features: "Features",
      back: "Back",
      shipsFrom: "Tracked EU delivery",
      satisfied: "30-day satisfaction guarantee",
      priceNote: "VAT incl., free shipping across Europe",
      allInclusive: "✅ All-inclusive price — shipping & taxes covered",
      exerciseWithdrawal: "Exercise my right of withdrawal",
      freeShipping: "Free shipping",
      shippingDetailsTitle: "Shipping details",
      chooseVariant: "Choose your edition",
      descriptionTitle: "The innovation in detail",
      faqTitle: "Frequently asked questions",
      badgeBestseller: "Best-seller",
      badgeNew: "New",
      outOfStockTitle: "Temporarily sold out",
      outOfStockMsg: "Leave your email to be notified first",
      waitlistEmailPlaceholder: "your@email.com",
      waitlistSubmit: "Notify me",
      waitlistSuccess: "Thank you. You'll be among the first to know.",
      outOfStockCta: "Out of stock",
      reviewsTitle: "They tried it, they adopted it",
      verifiedBadge: "Verified review",
      certificationsTitle: "Certifications",
      powerSupplyTitle: "Power supply",
      comparisonTitle: "Why not a classic neck fan?",
      crossSellTitle: "Complete your comfort setup",
      crossSellCta: "Discover",
      stickyAddCta: "Add — ",
    },
    checkout: {
      title: "Complete order",
      back: "Back to shop",
      contact: "Your details",
      shipping: "Shipping address",
      summary: "Summary",
      placeOrder: "Place order",
      processing: "Processing…",
      success: "Order confirmed",
      successMsg: "Thank you for trusting us. A confirmation email is on its way.",
      orderNumber: "Order number",
      continueShopping: "Continue shopping",
      fields: {
        email: "Email",
        firstName: "First name",
        lastName: "Last name",
        address: "Address",
        city: "City",
        postal: "Postal code",
        country: "Country",
        phone: "Phone (optional)",
      },
      simulationNote: "This is a simulated payment — no card will be charged.",
    },
    legal: {
      legalTitle: "Legal notice",
      cgvTitle: "Terms of sale",
      returnsTitle: "Return policy",
      contactTitle: "Contact us",
      faqTitle: "Frequently asked questions",
      contactSubmit: "Send message",
      contactSuccess: "Message received. We'll get back to you within 24h.",
      placeholder: "This page is being drafted. Below is placeholder content for site demonstration.",
    },
    common: { currency: "€", ttc: "VAT incl." },
  },
};

export const faqList = {
  fr: [
    { q: "Quels sont les délais de livraison ?",
      a: "Le Coussin Massant Chauffant est expédié depuis notre entrepôt en Allemagne par DHL en 3 à 7 jours ouvrés — stock disponible en Europe pour une livraison rapide. La Sphère Duo est expédiée en 8 à 14 jours ouvrés. Vous recevez un numéro de suivi par email dès l'expédition." },
    { q: "Comment suivre ma commande ?",
      a: "Un email avec votre numéro de suivi vous est envoyé dès que votre colis quitte l'entrepôt. Vous pouvez ensuite suivre la livraison en temps réel via le lien fourni." },
    { q: "Comment retourner un produit ?",
      a: "Vous disposez de 30 jours après réception pour nous retourner votre produit. Écrivez-nous à contact@myflovea.com — nous vous envoyons un bordereau prépayé gratuitement." },
    { q: "Les produits sont-ils garantis ?",
      a: "Oui — tous nos produits sont couverts par une garantie constructeur. En cas de problème, notre support basé en France répond en moins de 24h." },
    { q: "Quels moyens de paiement acceptez-vous ?",
      a: "Carte bancaire (Visa, Mastercard, Amex), Apple Pay, Google Pay et virement. Toutes les transactions sont sécurisées via cryptage SSL." },
    { q: "Livrez-vous en dehors de la France ?",
      a: "Oui — nous livrons dans toute l'Union Européenne, gratuitement. Les délais sont identiques (3 à 14 jours selon le produit)." },
    { q: "Quelle est la différence entre les variantes Tissu et Velours du coussin ?",
      a: "Le Tissu Standard (79€) est respirant et facile d'entretien — parfait pour le bureau et la voiture. Le Velours Premium (89€) offre un toucher plus doux et luxueux — idéal pour un usage canapé ou pour offrir." },
  ],
  en: [
    { q: "What are the delivery times?",
      a: "The Heated Massage Cushion ships from our warehouse in Germany via DHL in 3 to 7 business days — stock available in Europe for fast delivery. The Duo Sphere ships in 8 to 14 business days. You'll receive a tracking number by email as soon as your order is dispatched." },
    { q: "How do I track my order?",
      a: "You'll receive an email with your tracking number as soon as your parcel leaves the warehouse. You can then follow the delivery in real time." },
    { q: "How do I return a product?",
      a: "You have 30 days from delivery to return your product. Email us at contact@myflovea.com and we'll send you a free prepaid label." },
    { q: "Are the products warrantied?",
      a: "Yes — every product is covered by a manufacturer warranty. Our France-based support replies within 24h if anything goes wrong." },
    { q: "Which payment methods do you accept?",
      a: "Card (Visa, Mastercard, Amex), Apple Pay, Google Pay and bank transfer. All transactions are secured via SSL encryption." },
    { q: "Do you ship outside France?",
      a: "Yes — we deliver across the entire European Union, free of charge. Delivery times are the same (3 to 14 days depending on the product)." },
    { q: "What's the difference between Fabric and Velvet versions of the cushion?",
      a: "Standard Fabric (€79) is breathable and easy to care for — perfect for office and car. Premium Velvet (€89) offers a softer, more luxurious feel — ideal for sofa use or gifting." },
  ],
};
